export default __webpack_public_path__ + "static/media/snf.cad33d0d.png";